import { render, staticRenderFns } from "./NFe.vue?vue&type=template&id=b4ab22fa"
import script from "./NFe.js?vue&type=script&lang=js&external"
export * from "./NFe.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports